'use client'

import { createContext, useContext, useState, ReactNode } from 'react'

interface DemoContextType {
    selectedDemo: { url: string; title: string } | null
    openDemo: (url: string, title: string) => void
    closeDemo: () => void
}

const DemoContext = createContext<DemoContextType | undefined>(undefined)

export function useDemoContext() {
    const context = useContext(DemoContext)
    if (context === undefined) {
        throw new Error('useDemoContext must be used within a DemoProvider')
    }
    return context
}

interface DemoProviderProps {
    children: ReactNode
}

export function DemoProvider({ children }: DemoProviderProps) {
    const [selectedDemo, setSelectedDemo] = useState<{ url: string; title: string } | null>(null)

    const openDemo = (url: string, title: string) => {
        setSelectedDemo({ url, title })
    }

    const closeDemo = () => {
        setSelectedDemo(null)
    }

    return (
        <DemoContext.Provider value={{ selectedDemo, openDemo, closeDemo }}>
            {children}
        </DemoContext.Provider>
    )
}